module.exports = __webpack_public_path__ + "static/media/distribution-bg.1b54156e.jpg";